(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["center-image-with-marks-mobile"]) return;
  try {
    
var $ = null;
var points = document.querySelectorAll('.point_mobile');

window.addEventListener('load', function() {
  $ = window.$;

  var rtl = $('html').attr('dir') === 'rtl';

  $('#DescriptionsSlider').slick({
    rtl: rtl,
    dots: true,
  });

  $('#DescriptionsSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    for (var i = 0; i <= 3; i++) {
      points[i].classList.remove('active');
    }

    points[nextSlide].classList.add('active');
  });
})

var selectPoint = function(selectedIndex) {
  if ($) {
    $('#DescriptionsSlider').slick('slickGoTo', selectedIndex);
  }

  for (var i = 0; i <= 3; i++) {
    points[i].classList.remove('active');
  }

  points[selectedIndex].classList.add('active');
}

selectPoint(0);

points[0].addEventListener('click', function(event) {
  selectPoint(0);
})
points[1].addEventListener('click', function(event) {
  selectPoint(1);
})
points[2].addEventListener('click', function(event) {
  selectPoint(2);
})
points[3].addEventListener('click', function(event) {
  selectPoint(3);
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-categories-links"] && !Shopify.designMode) return;
  try {
    
var $ = null;

var goTo = function($, id){
  var id = id;

  return function(){
    if(!id){
      return; 
    }
 
    var element = $('#' + id);
 
    if(element.children().length == 0){
      return;
    }

    window.scrollTo({
      top: element.offset().top - 100, 
      behavior: 'smooth'
    });
  }
}

window.addEventListener('load', function() {
  $ = window.$;

  var links = $('.faq-category-link');

  for(var i = 0; i < links.length; i++){
    links.eq(i).find('.btn').on('click', goTo($, links.eq(i).data('title')))
  }

})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

window.addEventListener('load', function() {
  var $ = window.$;
  var blocksCounter = $('.links-mobile-list').length;

  var handleLinks = function(index){
    var index = index;

    return function(){
      var mobileItem = $('.links-mobile-list').eq(index);
      var arrow = $('.page-footer__blocks .arrow').eq(index);

      if(mobileItem.css('height') == '0px'){
        var height = mobileItem.children().length * 38 + "px";

        mobileItem.css('height', height);
        arrow.addClass('opened');
      } else {
        mobileItem.css('height', '0px');
        arrow.removeClass('opened');
      }
    }
  }

  for(var i = 0; i < blocksCounter; i++){
    const handler = handleLinks(i);

    $('.link-list-container-title').eq(i).on('click', handler);
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-contact"]) return;
  try {
    

window.addEventListener('load', function() {
  $ = window.$;

  $('#ContactUsSubject').on('click', function(event){
    event.stopPropagation();

    $('#ContactUsSubject').addClass('opened');

    if($('#ContactUsSubSubject').hasClass('opened')){
      $('#ContactUsSubSubject').removeClass('opened');
    }
  })

  $('#ContactUsSubSubject').on('click', function(event){
    event.stopPropagation();

    $('#ContactUsSubSubject').addClass('opened');

    if($('#ContactUsSubject').hasClass('opened')){
      $('#ContactUsSubject').removeClass('opened');
    }
  })
  
  var subjectItems = $('#SubjectDropdown li');

  for(var i = 0; i < subjectItems.length; i++){
    subjectItems.eq(i).on('click', function(event){
      var selectedSubject = event.currentTarget.dataset.option;

      $('#SubjectFormEmail').val(selectedSubject);
      $('#ContactUsSubSubject').removeClass('hidden');
      $('#SubSubjectFormEmail').val('');
      $('#ContactUsSubject').removeClass('is-empty');
      $('#ContactUsSubject').removeClass('opened');

      var subSubjectsContainers =$('#SubSubjectDropdown .sub-subject-container')

      for(var a = 0; a < subSubjectsContainers.length; a++){
        
        if(subSubjectsContainers.eq(a).data('subject') === selectedSubject ){
          subSubjectsContainers.eq(a).removeClass('hidden')
        } else {
          subSubjectsContainers.eq(a).addClass('hidden')
        }
      }

      event.stopPropagation();
    })
  }

  var subSubjectItems = $('#SubSubjectDropdown li');

  for(var i = 0; i < subSubjectItems.length; i++){
    subSubjectItems.eq(i).on('click', function(event){
      $('#SubSubjectFormEmail').val(event.currentTarget.dataset.option);
      $('#ContactUsSubSubject').removeClass('is-empty');
      $('#ContactUsSubSubject').removeClass('opened');
      event.stopPropagation();
    })
  }

  window.addEventListener('click', function(){
    if($('#ContactUsSubject').hasClass('opened')){
      $('#ContactUsSubject').removeClass('opened');
    }

    if($('#ContactUsSubSubject').hasClass('opened')){
      $('#ContactUsSubSubject').removeClass('opened');
    }
  })
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var buttonObserver = new MutationObserver(function (mutations) {
    setTimeout(function () {
      var element = document.querySelector('.shopify-payment-button__button');
      var text = document.querySelector('#buy-it-now').getAttribute('data-content');
      
      if(text && element && element.textContent !== text){
        element.textContent = text;
      }
    }, 0)
  });
  
  var buttonObserved = document.querySelector('#payment-button');
          console.log(buttonObserved," element");

  
  if (buttonObserved) {
    buttonObserver.observe(buttonObserved, { attributes: true, childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    

// @TODO Fix naming

var $ = null;
var customFilter = document.getElementById('CustomFilter');
var typeInput = document.getElementById('CustomTypeFilter');
var mobileCloseButton = document.getElementById('cc-filter-close-btn-mobile');
var counters = {
  product: 0,
  article: 0
}

if(typeInput){
  // Fetches all items from specified type, then update counter
  var handleTypeCount = function (type, id) {
    var params = (new URL(document.location)).searchParams;
    var q = params.get('q');

    if(!q){
      return;
    }

    fetch(window.location.pathname + '?q=' + q + "&type=" + type)
      .then(response =>  response.text())
      .then(responseText => {
        var fetchedHTML = document.implementation.createHTMLDocument();
        fetchedHTML.documentElement.innerHTML = responseText;

        var element = fetchedHTML.querySelector('.search-results-page');

        if(element){
          var count = element.getAttribute('data-items')
          
          $('#' + id).text(count);
          
          counters[type] = count;
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  // Updates result button (only in mobile view)
  updateResultsButtonCounter = function(){
    var counterElement = $('.cc-filter__result-counter');
    var value = 0;
    var keys = Object.keys(counters);

    for(var i = 0; i < keys.length; i++) {
      if(typeInput.value.includes(keys[i]) || !typeInput.value){
        value += parseInt(counters[keys[i]])
      }
    }

    counterElement.text(value);
  }

  var handleMobileButtonClick =  function(){
    customFilter.setAttribute('open', true);
    customFilter.classList.add('is-open');
    updateResultsButtonCounter();
  }

  // Sets all tags
  var updateActiveFilters = function(event){
    var thirdActiveSort = $('#cc-active-sort-3');
    var secondActiveSort = $('#cc-active-sort-2');
    var firstActiveFilter = $('#cc-active-filter-1');
    var secondActiveFilter = $('#cc-active-filter-2');
    var typeActiveFilters = $('.type-active-filters');
    var sortMobileButton = $('.cc-filters-control__btn.js-show-sort');
    var filtersMobileButton = $('.cc-filters-control__btn.js-show-filters');

    var params = (new URL(document.location)).searchParams;
    var typeInputValue = typeInput.value;
    var sortValue = params.get('sort_by');

    if(!typeActiveFilters || !firstActiveFilter || !secondActiveFilter || !secondActiveSort || !thirdActiveSort){
      return;
    }

    if(!typeInputValue && (!sortValue || sortValue === 'relevance')){
      thirdActiveSort.addClass('hidden');
      secondActiveSort.addClass('hidden');
      typeActiveFilters.addClass('hidden');
      firstActiveFilter.addClass('hidden');
      secondActiveFilter.addClass('hidden');
      sortMobileButton.removeClass('has-active-filters');
      filtersMobileButton.removeClass('has-active-filters');
    } else {
      typeActiveFilters.removeClass('hidden');

      if(typeInputValue.includes(firstActiveFilter.data('value'))) {
        firstActiveFilter.removeClass('hidden');
      } else {
        firstActiveFilter.addClass('hidden');
      }

      if(typeInputValue.includes(secondActiveFilter.data('value'))) {
        secondActiveFilter.removeClass('hidden');
      } else {
        secondActiveFilter.addClass('hidden');
      }

      if(secondActiveSort.data('value') == sortValue) {
        secondActiveSort.removeClass('hidden');
      } else {
        secondActiveSort.addClass('hidden');
      }

      if(thirdActiveSort.data('value') == sortValue) {
        thirdActiveSort.removeClass('hidden');
      } else {
        thirdActiveSort.addClass('hidden');
      }


      if(sortValue && sortValue !== 'relevance'){
        sortMobileButton.addClass('has-active-filters');
      }

      if(typeInputValue){
        filtersMobileButton.addClass('has-active-filters');
      }
    }
  }

  // Removes active sort
  var removeActiveSort = function(event) {
    var item = $('#sort-by-1');

    if(item) {
      item.click();
    }
  }

  // Removes active type filter
  var removeActiveFilter = function(event){
    var index = event.currentTarget.getAttribute("data-index");

    if(!index) {
      var items = [$('#cc-filter-type-1'), $('#cc-filter-type-2')];

      mobileCloseButton.click();

      for(var i = 0; i < items.length; i++) {
        if(items[i].is(':checked')){
          items[i].click();
        }
      }

      return;
    }

    var item = $('#cc-filter-type-' + index);

    if(item.is(':checked')){
      item.click();
    }
  }

  var removeAllActiveFilters = function(event){
    removeActiveFilter(event);
    removeActiveSort(event);
  }

// Sets new sort, then updates tags
  var sortFilterHandler = function(event){
    var sortMobileButton = $('.cc-filters-control__btn.js-show-sort');
    var item = $('#' + event.currentTarget.id);

    if(!item){
      return;
    }

    var index = item.data('index');

    if(index !== 1){
      $('.type-active-filters').removeClass('hidden');

      sortMobileButton.addClass('has-active-filters');
    } else {
      $('.type-active-filters').addClass('hidden');
    }

    var items = [$('#cc-active-sort-1'), $('#cc-active-sort-2'), $('#cc-active-sort-3')];

    for(var i = 0; i < items.length; i++){
      if(items[i].data('index') === index){
        items[i].removeClass('hidden');
      } else {
        items[i].addClass('hidden');
      }
    }
  }

  // Sets new type filter, then update tags and result button in mobile view
  var typeFilterHandler = function(event){
    var item = $('#' + event.currentTarget.id);
  
    if(!item){
      return;
    }

    var values = typeInput.value.split(',').filter(value => !!value);
 
    if(item.is(':checked')) {
      if(!values.length){
        typeInput.value = item.val().toLowerCase();  
      } else if (!values.includes(item.val().toLowerCase())){
        typeInput.value = typeInput.value + "," + item.val().toLowerCase();  
      }
    } else {
      var index = values.findIndex(function(value) {
        return value === item.val().toLowerCase();
      });

      if(index === -1){
        return;
      }

      values.splice(index, 1);

      typeInput.value = values.join(',');
    }

    updateActiveFilters();
    updateResultsButtonCounter();
  }
  
  window.addEventListener('load', function() {
    $ = window.$;

    var params = (new URL(document.location)).searchParams;

    var values = params.get('type').split(',');
    typeInput.value = values;

    $('#cc-filter-type-1').prop("checked", values.includes($('#cc-filter-type-1').val().toLowerCase()));
    $('#cc-filter-type-2').prop("checked", values.includes($('#cc-filter-type-2').val().toLowerCase()));

    if(params.get('init') === '1'){
      $('#cc-filter-type-1').prop("checked", false)
      $('#cc-filter-type-2').prop("checked", false)

      typeInput.value = '';
    }

    // Events on sort click
    $('#sort-by-1').on('click', sortFilterHandler);
    $('#sort-by-2').on('click', sortFilterHandler);
    $('#sort-by-3').on('click', sortFilterHandler);

    //Events on type filter click
    $('#cc-filter-type-1').on('click', typeFilterHandler);
    $('#cc-filter-type-2').on('click', typeFilterHandler);

    // Events on tag click
    $('#cc-active-sort-2').on('click', removeActiveSort);
    $('#cc-active-sort-3').on('click', removeActiveSort);
    $('#cc-active-filter-1').on('click', removeActiveFilter);
    $('#cc-active-filter-2').on('click', removeActiveFilter);
    $('#cc-active-filter-clear').on('click', removeAllActiveFilters);
    
    // Event on clear type filters click
    $('#cc-active-filter-clear-mobile').on('click', removeActiveFilter);

    // Event on mobile filter button click
    $('.cc-filters-control__btn.js-show-filters').on('click', handleMobileButtonClick);

    updateActiveFilters();
    handleTypeCount('product', 'cc-filter-counter-1');
    handleTypeCount('article', 'cc-filter-counter-2');
  })

  window.addEventListener('popstate', function() {
    window.location.reload();
  })
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    

window.addEventListener("load", function () {
  var $ = window.$;

  if ($(".cc-popup-form__response--success")[0]) {
    var url = new URL(document.location);
    var params = new URLSearchParams(url.search);

    params.delete("customer_posted");

    var newUrl = url.href.split("?")[0];
    var paramsString = params.toString();

    if(paramsString){
      newUrl = newUrl + "?" + paramsString;
    }

    window.history.replaceState(null, "", newUrl);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
      theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
